import { render, staticRenderFns } from "./ComplaintsPanel.vue?vue&type=template&id=070fe3ce&scoped=true&"
import script from "./ComplaintsPanel.vue?vue&type=script&lang=ts&"
export * from "./ComplaintsPanel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070fe3ce",
  null
  
)

export default component.exports